const categories = () => (
  <div>
    <p>Under construction</p>
  </div>
);

export default categories;
